"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferUnderPropertyLocationDto = instanceOfOfferUnderPropertyLocationDto;
exports.OfferUnderPropertyLocationDtoFromJSON = OfferUnderPropertyLocationDtoFromJSON;
exports.OfferUnderPropertyLocationDtoFromJSONTyped = OfferUnderPropertyLocationDtoFromJSONTyped;
exports.OfferUnderPropertyLocationDtoToJSON = OfferUnderPropertyLocationDtoToJSON;
exports.OfferUnderPropertyLocationDtoToJSONTyped = OfferUnderPropertyLocationDtoToJSONTyped;
/**
 * Check if a given object implements the OfferUnderPropertyLocationDto interface.
 */
function instanceOfOfferUnderPropertyLocationDto(value) {
    return true;
}
function OfferUnderPropertyLocationDtoFromJSON(json) {
    return OfferUnderPropertyLocationDtoFromJSONTyped(json, false);
}
function OfferUnderPropertyLocationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'displayAddress': json['displayAddress'] == null ? undefined : json['displayAddress'],
    };
}
function OfferUnderPropertyLocationDtoToJSON(json) {
    return OfferUnderPropertyLocationDtoToJSONTyped(json, false);
}
function OfferUnderPropertyLocationDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'displayAddress': value['displayAddress'],
    };
}
